import { render, staticRenderFns } from "./BooGoHeroSection.vue?vue&type=template&id=7709b1b6&scoped=true&"
import script from "./BooGoHeroSection.vue?vue&type=script&lang=js&"
export * from "./BooGoHeroSection.vue?vue&type=script&lang=js&"
import style0 from "./BooGoHeroSection.vue?vue&type=style&index=0&id=7709b1b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7709b1b6",
  null
  
)

export default component.exports